import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { motion, useInView, animate } from "framer-motion";

const runtimeConfig = (typeof window !== "undefined" && window.APP_CONFIG) || {};
const API = `${runtimeConfig.API_BASE || "https://tarovarvara.ru"}/api`;

function formatRu(n) {
  return Math.floor(n).toLocaleString("ru-RU");
}

// Live "readings done" counter: seeds from backend, ticks up over time.
export const LiveCounter = () => {
  const [value, setValue] = useState(null);
  const [display, setDisplay] = useState("—");
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const incRef = useRef(240);

  // Seed from backend
  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/counter`)
      .then((res) => {
        if (!mounted) return;
        incRef.current = res.data.increment_seconds || 240;
        setValue(res.data.count);
      })
      .catch(() => {
        if (mounted) setValue(12800);
      });
    return () => {
      mounted = false;
    };
  }, []);

  // Count-up animation when it scrolls into view
  useEffect(() => {
    if (value == null || !inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(formatRu(v)),
    });
    return () => controls.stop();
  }, [value, inView]);

  // Slow live increment
  useEffect(() => {
    if (value == null) return;
    const ms = Math.max(2000, (incRef.current || 240) * 1000);
    const id = setInterval(() => {
      setValue((v) => (v == null ? v : v + 1));
      setDisplay((d) => formatRu(parseInt(String(d).replace(/\D/g, ""), 10) + 1));
    }, ms);
    return () => clearInterval(id);
  }, [value]);

  return (
    <div
      ref={ref}
      className="inline-flex items-center gap-3 rounded-full border border-[#D4AF6E]/25 bg-[#111133]/60 px-5 py-2.5 backdrop-blur-sm"
      data-testid="live-counter"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#F0C674] opacity-70" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#F0C674]" />
      </span>
      <span className="text-sm text-[#EDE6D3]/80">
        Уже{" "}
        <motion.span
          key={display}
          className="font-semibold text-gold"
          data-testid="counter-value"
        >
          {display}
        </motion.span>{" "}
        разборов сделано
      </span>
    </div>
  );
};
